<script setup lang="ts">
import { SortBy } from "element-plus";
import { ref } from "vue";

defineProps<{
  columns: any[];
  data: any[];
  rowKey: string;
  rowClass?: any;
  width: number;
  height: number;
  sortState: SortBy;
}>();
const emit = defineEmits<{
  (e: "column-sort", sortBy: SortBy): void;
}>();

const innerRef = ref(null);

defineExpose({
  getTableRef() {
    return innerRef;
  },
});

const onSort = (sortBy: SortBy) => {
  emit("column-sort", sortBy);
  console.log(sortBy);
};
</script>
<template>
  <el-table-v2
    ref="innerRef"
    :columns="columns"
    :data="data"
    :row-class="rowClass"
    :row-key="rowKey"
    :width="width"
    :height="height"
    :scrollbar-always-on="true"
    :v-scrollbar-size="35"
    :h-scrollbar-size="15"
    class="mainTable"
    :sort-by="sortState"
    fixed
    tabindex="1"
    @column-sort="onSort"
  >
  </el-table-v2>
</template>

<style lang="less">
.mainTable {
  .cell {
    word-break: normal;

    // display: flex;
    // box-sizing: content-box;
    // margin: 0 -8px;
    // padding: 2px 8px;
    // height: 100%;
    // width: 100%;
    // align-items: center;
    // gap: 5px;

    // transition: all 0.3s ease;
  }

  // .ep-table-v2__header-cell {
  //   > div {
  //     height: 100%;
  //     justify-content: flex-end;
  //   }
  // }

  // .column {
  //   // keep this for development testing
  //   // border-left: 1px solid green;
  //   // border-right: 1px solid red;
  //   border-left: 1px solid var(--ep-border-color-extra-light);
  //   border-right: 1px solid var(--ep-border-color-extra-light);
  // }

  .el-table-v2__row-cell {
    height: auto;
  }

  // .ep-table-v2__row-cell.is-align-right {
  //   .cell {
  //     justify-content: flex-end;
  //     text-align: right;
  //   }
  // }

  // .ep-table-v2__row-cell.is-align-center {
  //   .cell {
  //     justify-content: center;
  //     text-align: center;
  //   }
  // }

  .el-table-v2__row-cell {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    // padding-left: 1rem;
  }

  // .lastRow {
  //   border-bottom: 2px solid red;
  // }
  .el-table-v2__header-cell {
    padding-left: 8px;
    &.is-sortable.is-align-center {
      padding-left: 22px;
    }
  }

  .el-table-v2__row-cell {
    padding-left: 8px;

    .el-button.el-button--primary.is-text {
      padding-left: 8px;
    }
  }
}
</style>
